import { createContext, useContext } from 'react';

export const DirtyFormContext = createContext({
    isDirty: false,
    setIsDirty: () => {},
});

export const useDirtyForm = () => useContext(DirtyFormContext);